<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.customer')"
    resource="customers"
    :batch-actions="batchActions"
    index-exec-filter-router-type="push"
    :custom-show-page="CustomShowPage"
  >
    <template slot="action">
      <bean-import-button
        can='customers.create'
        :buttonText="$t('import')"
        :tooltipText="$t('importTemplate')"
        url="/customers/import"
        :loadingToast="$t('importLoadingToast')"
        :fileChangeHandler="handleImprtFileChange"
      >
        <template slot="download">
          <el-popover trigger="hover">
            <div style="cursor: pointer;" @click="downloadTpl">下载模板</div>
            <i class="el-icon-info btn-tip-trigger" slot="reference" @click.stop></i>
          </el-popover>
        </template>
      </bean-import-button>
    </template>
    <template slot="form-action">
      <bean-route-button v-if="type === 'edit'" style="margin-left: 10px" label="跟进记录" :to="{ name: 'follow_records.index', query: { customer_id_eq: $route.params.id } }"></bean-route-button>
    </template>
  </bean-source-page>
</template>

<script>
import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import customFilterColumnsExtend from '@/custom_filter_columns_extend';
import { filterColumns, filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/customers.js';
import { formColumnsExtend as customerJushuitanOrderRelationFormCloumnsExtend } from '../admin_entities/customer_jushuitan_order_relation_detail.js';
import { columnsExtend as followRecordColumnsExtend, formColumnsExtend as followRecordFormColumnsExtend } from '../admin_grapes/follow_records.js';
import { formColumnsExtend as memoFormColumnsExtend } from '../admin_grapes/memos.js';
import { abilityService } from 'beans-admin-plugin';
import _ from 'lodash';
import pluralize from 'pluralize';
import { TAG_TYPE, TRADE_HEAT } from '@/constants';
import Utils from '../components/utils.vue';
import CustomShowPage from '@/components/custom-show-page/index.vue';
import moment from 'moment';
import { displayText } from '@/custom_models_extend';

const CUSTOMER_RESEARCH_URL = 'https://research.quickshow.com/research?q=';

@Component
export default class Customers extends Mixins(Vue, Utils) {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {};
  created() {
    if (['business_executive', 'salesman', 'customer_service', 'channel_business_executive'].includes(this.roleKind)) {
      this.form = {
        user_id: this.currentUser.id,
      }
    }
  }

  CustomShowPage = CustomShowPage

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      { prop: 'keyword', label: this.$t('keyword'), renderCell: 'input' },
      abilityService.can('users.read_options') && {
        key: 'user_id_eq',
        renderCell: {
          props: {
            clearable: true,
            xRemotePreload: async () => {
              return (await this.$request.get('users/read_options', { per_page: 100, ...this.userOptionsFilter })).data.map(item => ({ value: item.id, label: displayText(item) }));
            },
            xRemoteSearch: async (keyword) => {
              return (await this.$request.get('users/read_options', { keyword, ...this.userOptionsFilter })).data.map(item => ({ value: item.id, label: displayText(item) }));
            }
          },
        }
      },
      {
        key: 'user_id_null',
        label: '公海客户',
        renderCell: {
          props: {
            clearable: true,
          }
        }
      },
      {
        key: 'no_contact_info',
        label: '无联系方式',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            options: [
              { value: true, label: '是' },
              { value: false, label: '否' }
            ]
          }
        }
      },
      {
        key: 'orders_count_eq',
        label: '订单数',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            options: [
              { value: 0, label: '无订单' },
              { value: 1, label: '首单' }
            ]
          }
        }
      },
      ['salesman', 'business_executive', 'channel_business_executive', 'customer_service'].includes(this.roleKind) && {
        prop: 'need_supplement_information',
        label: '待录入信息',
        renderCell: {
          component: 'switch'
        }
      },
      ['salesman', 'business_executive', 'channel_business_executive', 'customer_service'].includes(this.roleKind) && {
        prop: 'need_follow',
        label: '待触达',
        renderCell: {
          component: 'switch'
        }
      },
      ['salesman', 'business_executive', 'channel_business_executive', 'customer_service'].includes(this.roleKind) && {
        prop: 'pending_approve',
        label: '待转接确认',
        renderCell: {
          component: 'switch'
        }
      },
      {
        prop: 'related',
        label: '是否相关',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            options: [
              { value: true, label: this.$t('bean.yes') },
              { value: false, label: this.$t('bean.no') }
            ]
          }
        }
      },
      { key: 'create_date_gteq', label: `${this.$t('customer.createDate')}${this.$t('gteqDatetime')}` },
      { key: 'create_date_lteq', label: `${this.$t('customer.createDate')}${this.$t('lteqDatetime')}` },
      'customer_level_id_eq',
      'customer_tags_id_eq',
      'customer_kind_id_eq',
      {
        prop: 'user_team_id_eq',
        label: '团队/小组',
        renderCell: {
          component: 'app-team-tree-select',
        }
      },
      // {
      //   prop: 'taggings_tag_id_eq',
      //   label: '系统标签',
      //   renderCell: {
      //     component: 'select',
      //     props: {
      //       clearable: true,
      //       xRemotePreload: async () => {
      //         const { data } = await this.$request.get('/acts_as_taggable_on/tags/read_options', {
      //           taggings_context_eq: 'annual_status',
      //           per_page: 1000
      //         })
      //         return data.map(tag => ({ value: tag.id, label: tag.name }))
      //       },
      //       xRemoteSearch: async (keyword) => {
      //         const { data } = await this.$request.get('/acts_as_taggable_on/tags/read_options', {
      //           keyword: keyword,
      //           taggings_context_eq: 'annual_status',
      //           per_page: 1000
      //         })
      //         return data.map(tag => ({ value: tag.id, label: tag.name }))
      //       }
      //     }
      //   }
      // },
      {
        prop: 'new_customer_in_current_year_eq',
        label: this.$t('customer.newCustomerInCurrentYear'),
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            options: [
              { value: true, label: '是' },
              { value: false, label: '否' }
            ]
          }
        }
      },
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      { key: 'name', fixed: true },
      { key: 'manager', fixed: true },
      type === 'show' && 'phone',
      abilityService.can('users.read_options') && { key: 'user', fixed: true },
      abilityService.can('users.read_options') && 'assign_to_user',
      { key: 'customer_level', width: 120, fixed: true },
      type === 'show' && 'customer_level_fixed',
      { key: 'customer_source', width: 120 },
      { key: 'customer_kind', width: 120, sortable: false },
      { key: 'customer_connection', width: 140 },
      { key: 'customer_tags', width: 120 },
      type === 'show' && 'customer_transaction',
      { key: 'customer_business_models', width: 120, sortable: false },
      { key: 'product_styles', width: 120, sortable: false },
      { key: 'sale_channels', width: 120, sortable: false },
      { key: 'new_customer_in_current_year', sortable: false, renderCell: 'bool' },
      {
        key: 'trade_heat',
        width: 120,
        renderCell: (h, { props: { value } }) => {
          if (!value) { return }

          return <el-tag type={TAG_TYPE[value]}>{TRADE_HEAT[value]}</el-tag>;
        },
        filterColumns: [{
          prop: 'trade_heat_eq',
          renderCell: {
            component: 'select',
            props: {
              clearable: true,
              options: _.map(TRADE_HEAT, (label, value) => ({ value, label }))
            }
          }
        }]
      },
      { key: 'last_7_day_order_qty', width: 130 },
      { key: 'last_7_day_order_amount', width: 130 },
      { key: 'last_30_day_order_qty', width: 140 },
      { key: 'last_30_day_order_amount', width: 140 },
      { key: 'last_month_order_qty', width: 120 },
      { key: 'last_month_order_amount', width: 120 },
      {
        key: 'create_date',
        width: 120
      },
      { key: 'last_follow_record_of_user_followed_at', width: 160, renderCell: 'time' },
      'rest_amount',
      type === 'show' && 'address',
      type === 'show' && 'wechat',
      type === 'show' && 'has_production_capacity',
      type === 'show' && 'has_design_capability',
      type === 'show' && 'price_preference',
      type === 'show' && 'inquiry_content',
      type === 'show' && 'brand',
      type === 'show' && 'sales_ability',
      type === 'show' && 'files',
      type === 'show' && {
        key: 'follow_records',
        renderCell: (h, { props: { value } }) => {
          return <bean-table height={null} value={value} columns={followRecordColumnsExtend(['user', 'followed_at', 'content', 'media'])} />
        },
      },
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    const extendedColumns = columnsExtend(array)
    const allFilterColumns = customFilterColumnsExtend(filterColumns)
    _.each(extendedColumns, (column) => {
      if (column.sortable !== false) {
        column.sortable = true
      }
      if (!column.filterColumns) {
        if (allFilterColumns[`${column.prop}_cont`]) {
          column.filterColumns = [allFilterColumns[`${column.prop}_cont`]]
        } else if (allFilterColumns[`${column.prop}_eq`]) {
          column.filterColumns = [allFilterColumns[`${column.prop}_eq`]]
        } else if (abilityService.can(`${pluralize(column.prop)}.read_options`) && allFilterColumns[`${column.prop}_id_eq`]) {
          if (column.prop === 'customer_source') {
            column.filterColumns = [_.merge(allFilterColumns[`${column.prop}_id_in`], { renderCell: { props: { multiple: true } } })]
          } else {
            column.filterColumns = [allFilterColumns[`${column.prop}_id_eq`]]
          }
        }
      }
    })

    return extendedColumns
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'name',
      'manager',
      {
        key: 'phone',
        renderCell: {
          required: true
        }
      },
      type === 'new' && {
        key: 'user_id',
        renderCell: {
          // required: true,
          props: {
            clearable: true,
            xRemotePreload: async () => {
              let options = this.userOptionsFilter
              if (this.roleKind === 'salesman' || this.roleKind === 'customer_service') {
                options = { id_eq: this.currentUser.id }
              }
              return (await this.$request.get('users/read_options', { per_page: 100, ...options })).data.map(item => ({ value: item.id, label: displayText(item) }));
            },
            xRemoteSearch: async (keyword) => {
              let options = this.userOptionsFilter
              if (this.roleKind === 'salesman' || this.roleKind === 'customer_service') {
                options = { id_eq: this.currentUser.id }
              }
              return (await this.$request.get('users/read_options', { keyword, ...options })).data.map(item => ({ value: item.id, label: displayText(item) }));
            }
          },
          domProps: {
            style: 'width: 100%'
          }
        }
      },
      'customer_level_id',
      'customer_level_fixed',
      {
        key: 'customer_source_id',
        renderCell: {
          required: true
        }
      },
      'customer_kind_id',
      'customer_connection_id',
      'customer_tag_ids',
      'customer_transaction_id',
      'customer_business_model_ids',
      'product_style_ids',
      'sale_channel_ids',
      'address',
      {
        key: 'wechat',
        renderCell: {
          required: true
        }
      },
      'has_production_capacity',
      'has_design_capability',
      'price_preference',
      {
        key: 'inquiry_content',
        renderCell: {
          required: true
        }
      },
      'brand',
      'sales_ability',
      {
        key: 'files',
        renderCell: {
          required: true
        }
      },
      false && { // 客户编辑不再显示聚水潭订单关联
        key: 'customer_jushuitan_order_relations',
        renderCell: {
          component: 'nestForm',
          props: {
            columns: (object) => {
              return customerJushuitanOrderRelationFormCloumnsExtend(['jushuitan_order_foreign_key', 'jushuitan_order_foreign_key_value'], { data: object, type: type })
            }
          }
        }
      },
      type === 'edit' && {
        key: 'new_customer_in_current_year',
        label: this.$t('customer.newCustomerInCurrentYear'),
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            placeholder: '是否当前年份新客',
            options: [
              { value: true, label: '是' },
              { value: false, label: '否' }
            ]
          }
        }
      }
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload, type }) {
    return [
      row.can_update && {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'customers.edit', params: { id: row.id } }
        }
      },
      row.can_follow && {
        component: 'dialogFormButton',
        props: {
          label: '跟进',
          columns: followRecordFormColumnsExtend([
            'followed_at',
            {
              key: 'follow_key_item_ids',
              renderCell: {
                props: {
                  multiple: true,
                  xRemotePreload: async () => {
                    return (await this.$request.get('follow_key_items/read_options')).data.map(item => ({ value: item.id, label: item.name }));
                  },
                },
              }
            },
            'content',
            {
              key: 'media',
              renderCell: {
                props: {
                  accept: 'image/*,.csv,.pdf,.txt,.xlsx,.docx,.xls,.doc',
                  type: ['image', 'csv', 'application/pdf', 'text/plain', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
                  clipboard: true,
                  drag: true,
                }
              }
            },
            'task_assignment_id',
          ], { data: {}, type: 'new' }),
          value: {
            task_assignment_id: this.$route.query.task_assignment_id,
            followed_at: moment().format('YYYY-MM-DD HH:mm:ss'),
          },
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.post('/follow_records', { ...value, customer_id: row.id }));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      {
        component: 'dropdownButton',
        props: {
          title: '更多',
          buttons: [
            {
              component: 'routeButton',
              props: {
                label: '查看订单',
                to: { name: 'jushuitan_orders.index', query: { customer_id_eq: row.id } }
              }
            },
            {
              component: 'button',
              props: {
                label: '前往背调',
                type: 'primary',
              },
              on: {
                click: () => {
                  window.open(`${CUSTOMER_RESEARCH_URL}${encodeURIComponent(row.name)}`, '_blank', 'noopener,noreferrer');
                }
              }
            },
            row.can_assign && {
              component: 'dialogFormButton',
              props: {
                label: '转接',
                type: 'primary',
                value: {},
                columns: formColumnsExtend([{
                  key: 'user_id',
                  renderCell: {
                    props: {
                      xRemotePreload: async () => {
                        return (await this.$request.get('users/read_options', { per_page: 100, role_kind_in: ['salesman', 'customer_service', 'business_executive', 'channel_business_executive'], id_not_eq: this.currentUser.id })).data.map(item => ({ value: item.id, label: displayText(item) }));
                      },
                      xRemoteSearch: async (keyword) => {
                        return (await this.$request.get('users/read_options', { keyword, role_kind_in: ['salesman', 'customer_service', 'business_executive', 'channel_business_executive'], id_not_eq: this.currentUser.id })).data.map(item => ({ value: item.id, label: displayText(item) }));
                      }
                    },
                  }
                }], { data: {} }),
                submitHandler: async (value) => {
                  await this.$autoLoading(this.$request.put(`/customers/${row.id}/assign`, value));
                  this.$message.success(this.$t('operateSuccess'));
                  if (type === 'show') {
                    this.$router.push({ name: 'customers.index' });
                  } else {
                    reload();
                  }
                }
              }
            },
            row.can_apply_assign && {
              component: 'dialogFormButton',
              props: {
                label: '申请转接',
                type: 'primary',
                value: {},
                columns: formColumnsExtend([{
                  key: 'user_id',
                  renderCell: {
                    props: {
                      xRemotePreload: async () => {
                        return (await this.$request.get('users/read_options', { per_page: 100, role_kind_in: ['salesman', 'customer_service', 'business_executive', 'channel_business_executive'], id_not_eq: this.currentUser.id })).data.map(item => ({ value: item.id, label: displayText(item) }));
                      },
                      xRemoteSearch: async (keyword) => {
                        return (await this.$request.get('users/read_options', { keyword, role_kind_in: ['salesman', 'customer_service', 'business_executive', 'channel_business_executive'], id_not_eq: this.currentUser.id })).data.map(item => ({ value: item.id, label: displayText(item) }));
                      }
                    },
                  }
                }], { data: {} }),
                submitHandler: async (value) => {
                  await this.$autoLoading(this.$request.put(`/customers/${row.id}/apply_assign`, value));
                  this.$message.success(this.$t('operateSuccess'));
                  reload();
                }
              }
            },
            row.can_cancel_apply_assign && {
              component: 'confirmButton',
              props: {
                label: '撤销转接',
                type: 'primary',
              },
              on: {
                confirm: async () => {
                  await this.$autoLoading(this.$request.put(`/customers/${row.id}/cancel_apply_assign`));
                  this.$message.success(this.$t('operateSuccess'));
                  reload();
                }
              }
            },
            row.can_approve_assign && {
              component: 'confirmButton',
              props: {
                label: '同意转接',
                type: 'primary',
              },
              on: {
                confirm: async () => {
                  await this.$autoLoading(this.$request.put(`/customers/${row.id}/approve_assign`));
                  this.$message.success(this.$t('operateSuccess'));
                  reload();
                }
              }
            },
            row.can_reject_assign && {
              component: 'confirmButton',
              props: {
                label: '拒绝转接',
                type: 'primary',
              },
              on: {
                confirm: async () => {
                  await this.$autoLoading(this.$request.put(`/customers/${row.id}/reject_assign`));
                  this.$message.success(this.$t('operateSuccess'));
                  if (type === 'show') {
                    this.$router.push({ name: 'customers.index' });
                  } else {
                    reload();
                  }
                }
              }
            },
            (row.can_release || row.can_business_executive_release) && {
              component: 'button',
              props: {
                label: '释放公海',
                type: 'primary',
              },
              on: {
                click: async () => {
                  const shouldForceRelease = row.can_business_executive_release && row.user_id !== this.currentUser.id;
                  const { value } = await this.$prompt(shouldForceRelease ? '请输入强制流转原因' : '请输入释放原因', '释放公海', {
                    inputType: 'textarea',
                    inputValidator: v => (!!v && !!v.trim()) || '原因不能为空',
                  });
                  if (shouldForceRelease) {
                    await this.$autoLoading(this.$request.put(`/customers/${row.id}/business_executive_release`, { reason: value.trim() }));
                  } else {
                    await this.$autoLoading(this.$request.put(`/customers/${row.id}/release`, { reason: value.trim() }));
                  }
                  this.$message.success(this.$t('operateSuccess'));
                  reload();
                }
              }
            },
            {
              component: 'dialogFormButton',
              can: 'memos.create',
              props: {
                label: '备忘',
                columns: memoFormColumnsExtend([
                  'remind_at',
                  'content',
                ], { data: {}, type: 'new' }),
                value: {},
                submitHandler: async (value) => {
                  await this.$autoLoading(this.$request.post('/memos', { ...value, customer_id: row.id }));
                  this.$message.success(this.$t('operateSuccess'));
                  reload();
                }
              }
            },
            row.can_destroy && {
              component: 'confirmButton',
              props: {
                label: this.$t('destroy'),
                type: 'danger',
                can: 'customers.destroy'
              },
              on: {
                confirm: () => remove(row.id)
              }
            },
          ]
        }
      }
    ].filter(Boolean);
  }

  batchActions({ selection }, { resource }) {
    const exportClick = async (selection) => {
      if (selection.length === 0) {
        await this.$autoLoading(this.$request.get(`/${resource}/export`, { ...this.$route.query }));
      } else {
        await this.$autoLoading(this.$request.get(`/${resource}/export`, { ...this.$route.query, id_in: _.map(selection, item => item.id) }));
      }

      this.$message.success(this.$t('exporting'));
    }

    const batchDelete = async (selection) => {
      const deletableCustomers = _.filter(selection, 'can_destroy');

      if (deletableCustomers.length === 0) {
        this.$message.warning('没有可删除的客户');
        return;
      }

            try {
        await this.$confirm(`确定要删除 ${deletableCustomers.length} 个客户吗？`);
        await this.$autoLoading(this.$request.delete('/customers/batch_destroy', { id_in: _.map(deletableCustomers, 'id') }));

        this.$message.success(`成功删除 ${deletableCustomers.length} 个客户`);
        window.location.reload();
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error(`删除失败: ${error.message || error}`);
        }
      }
    }

    return [
      () => <el-button type='primary' onClick={() => exportClick(selection)}><i class='el-icon-download'></i>{this.$t('export')}</el-button>,
      abilityService.can('customers.destroy') && (() => <el-button type='danger' onClick={() => batchDelete(selection)}><i class='el-icon-delete'></i>批量删除 ({_.filter(selection, 'can_destroy').length})</el-button>),
      ..._.map([{
        records: _.filter(selection, item => item.can_release && item.user_id === this.currentUser.id),
        label: '释放',
        action: 'release',
        can: 'customers.release',
      }, {
        records: _.filter(selection, item => item.can_business_executive_release && item.user_id !== this.currentUser.id),
        label: '强制流转',
        action: 'business_executive_release',
        can: 'customers.release',
      }, {
        records: _.filter(selection, 'can_assign'),
        label: '转接',
        action: 'assign',
        component: 'dialogFormButton',
        can: 'customers.assign',
      }, {
        records: _.filter(selection, 'can_apply_assign'),
        label: '申请转接',
        action: 'apply_assign',
        component: 'dialogFormButton',
        can: 'customers.apply_assign',
      }, {
        records: _.filter(selection, 'can_cancel_apply_assign'),
        label: '撤销申请转接',
        action: 'cancel_apply_assign',
        can: 'customers.cancel_apply_assign',
      }, {
        records: _.filter(selection, 'can_approve_assign'),
        label: '同意转接申请',
        action: 'approve_assign',
        can: 'customers.approve_assign',
      }, {
        records: _.filter(selection, 'can_reject_assign'),
        label: '拒绝转接申请',
        action: 'reject_assign',
        can: 'customers.reject_assign',
      }], config => {
        const disabled = config.records.length === 0

        if (config.component === 'dialogFormButton') {
          return {
            component: 'dialogFormButton',
            props: {
              can: config.can,
              label: disabled ? config.label : `${config.label} (${config.records.length})`,
              triggerButtonProps: {
                type: 'primary',
                disabled: disabled,
              },
              value: {},
              columns: formColumnsExtend([{
                key: 'user_id',
                renderCell: {
                  props: {
                    xRemotePreload: async () => {
                      let params = { ...this.userOptionsFilter }
                      if (config.action === 'assign' || config.action === 'apply_assign') {
                        params = { role_kind_in: ['salesman', 'customer_service', 'business_executive', 'channel_business_executive'], id_not_eq: this.currentUser.id }
                      }
                      return (await this.$request.get('users/read_options', { per_page: 100, ...params, id_not_eq: this.currentUser.id })).data.map(item => ({ value: item.id, label: displayText(item) }));
                    },
                    xRemoteSearch: async (keyword) => {
                      let params = { ...this.userOptionsFilter }
                      if (config.action === 'assign' || config.action === 'apply_assign') {
                        params = { role_kind_in: ['salesman', 'customer_service', 'business_executive', 'channel_business_executive'], id_not_eq: this.currentUser.id }
                      }
                      return (await this.$request.get('users/read_options', { keyword, ...params, id_not_eq: this.currentUser.id })).data.map(item => ({ value: item.id, label: displayText(item) }));
                    }
                  },
                }
              }], { data: {}, type: 'new' }),
              submitHandler: async (value) => {
                await this.$confirm(`确定${config.label} ${_.join(_.map(config.records, 'name'), ', ')}?`)
                await this.$autoLoading(this.$request.put(`/customers/${config.action}`, { ...value, id_in: _.map(config.records, 'id') }));
                this.$message.success(this.$t('operateSuccess'));
                window.location.reload();
              }
            }
          }
        }

        return {
          component: 'button',
          props: {
            can: config.can,
            label: disabled ? config.label : `${config.label} (${config.records.length})`,
            type: 'primary',
            disabled: disabled
          },
          on: {
            click: async () => {
              let extra = {}
              if (config.action === 'business_executive_release' || config.action === 'release') {
                const { value } = await this.$prompt(`${config.action === 'business_executive_release' ? '请输入强制流转原因' : '请输入释放原因'}（将应用于 ${config.records.length} 个客户）`, '释放公海', {
                  inputType: 'textarea',
                  inputValidator: v => (!!v && !!v.trim()) || '原因不能为空',
                })
                extra = { reason: value.trim() }
              } else {
                await this.$confirm(`确定${config.label} ${_.join(_.map(config.records, 'name'), ', ')}?`)
              }
              await this.$autoLoading(this.$request.put(`/customers/${config.action}`, { id_in: _.map(config.records, 'id'), ...extra }));
              this.$message.success(this.$t('operateSuccess'));
              window.location.reload();
            }
          }
        }
      }),
    ].filter(Boolean);
  }

  async downloadTpl() {
    const result = await this.$request.get('/customers/import_template', {}, { responseType: 'blob', return_res: true, timeout: 5 * 60 * 1000 })
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    const blob = new Blob([result.data]);
    a.href = window.URL.createObjectURL(blob);
    a.download = '客户导入模板.xlsx';
    a.click();
    document.body.removeChild(a);
  }

  async upload(file) {
    const form = new FormData();
    form.append('file_message', file);
    const requestConfig = {
      headers: { 'Content-Type': 'multipart/form-data' },
      responseType: 'blob',
      return_res: true,
      // 1小时超时
      timeout: 1 * 60 * 60 * 1000
    }
    const result = await this.$request.post('/customers/import', form, requestConfig);
    if (result.headers['x-error-message']) {
      throw new Error(decodeURIComponent(result.headers['x-error-message']));
    }
    if (+result.headers['x-error-count'] > 0) {
      this.download(new Blob([result.data]), `${this.$t('bean.error_massage')}.xlsx`);
      throw new Error(this.$t('bean.importFail'));
    }
  }

  // 为了支持导入成功之后刷新页面
  async handleImprtFileChange(e) {
    const file = e.target.files[0];
    this.importing = true;
    let toastInstance = null;
    if (this.loadingToast) {
      toastInstance = this.$message.info({
        message: this.loadingToast,
        duration: 0,
        showClose: true
      });
    }
    try {
      await this.upload(file);
      this.$message.success(this.$t('bean.importSuccess'));
      this.$router.push({ name: 'customers.index' });
    } catch (e) {
      const msg = e.message || this.$t('bean.importFail');
      this.$message.error(msg);
    } finally {
      this.importing = false;
      if (toastInstance) {
        toastInstance.close();
      }
    }
    e.target.value = '';
  }
}

export const route = [
  {
    path: '/customers',
    name: 'customers.index',
    component: Customers,
    props: {
      type: 'index',
    }
  },
  {
    path: '/customers/new',
    name: 'customers.new',
    component: Customers,
    props: {
      type: 'new',
    }
  },
  {
    path: '/customers/:id',
    name: 'customers.show',
    component: Customers,
    props: {
      type: 'show',
    }
  },
  {
    path: '/customers/:id/edit',
    name: 'customers.edit',
    component: Customers,
    props: {
      type: 'edit'
    }
  }
]
</script>

<style scoped>
.background-check-result-dialog-content {
  max-height: 60vh;
  overflow: auto;
  word-break: break-word;
  line-height: 1.6;
}

.background-check-result-dialog-content /deep/ h2 {
  margin: 0 0 16px;
  font-size: 20px;
}

.background-check-result-dialog-content /deep/ h3 {
  margin: 18px 0 10px;
  padding-bottom: 6px;
  border-bottom: 1px solid #ebeef5;
  font-size: 16px;
}

.background-check-result-dialog-content /deep/ ul {
  margin: 0 0 12px;
  padding-left: 22px;
}

.background-check-result-dialog-content /deep/ li {
  margin: 6px 0;
}

.background-check-result-dialog-content /deep/ p {
  margin: 0 0 10px;
}
</style>
